const WEEKLY_CHECKIN_CTA_CATEGORIES = Object.freeze({
  cta_people: "people",
  cta_animals: "animals",
  cta_environment: "environment",
});

export function weeklyCheckinCategoryFromSearch(search) {
  const params = new URLSearchParams(search);
  const category = WEEKLY_CHECKIN_CTA_CATEGORIES[params.get("utm_content") || ""];
  if (
    params.get("utm_source") !== "idetect"
    || params.get("utm_medium") !== "email"
    || params.get("utm_campaign") !== "weekly_checkin"
    || !category
    || params.get("report_category") !== category
  ) {
    return "";
  }
  return category;
}
